export function formatTime(time) {
    const date = new Date(time);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
}

export function formatNumber(value, decimals = 0) {
    if (value == null) return '0';
    return value.toFixed(decimals);
}

export function formatCoordinates(value, hemispheres) {
    if (value == null) return '-';
    // format coordinates provided as float to degrees, minutes, seconds
    const absCoord = Math.abs(value);
    const degrees = Math.floor(absCoord);
    const minutes = Math.floor((absCoord - degrees) * 60);
    const seconds = Math.round((absCoord - degrees - minutes / 60) * 3600);
    return `${value >= 0 ? hemispheres[0] : hemispheres[1]}${degrees}°${minutes}'${seconds}"`;
}

export function formatTemperature(value) {
    if (value == null) return '0';
    return typeof value === 'number' ? `${value > 0 ? '+' : ''}${value.toFixed(0)}°C` : 'N/A';
}